<template>
    <v-card>
        <delete-dialog @success="deleteDiscount" :confirm-loading="deleteConfirmLoading" @closeDialog="cancelDelete"  :dialog="delete_dialog"
                       title="Discount Offer"></delete-dialog>
        <v-data-table
                :page.sync="page"
                :items="items"
                :headers="headers"
                hide-default-footer
        >
            <template v-slot:item.id="{ item }">
                <span class="table-users-srno">{{item.id}}</span>
            </template>

            <template v-slot:item.name="{ item }">
                <span class="table-users-name">{{item.amount}}</span>
            </template>
            <template v-slot:item.is_percent="{ item }">
                <span class="table-users-name">{{item.is_percent?'Percentile':'Non Percentile'}}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link class="profile-link" active-class :exact="true" :to="{name: 'EditDiscount',params:{id:item.id}}">
                    <v-icon color="success">mdi-file-edit</v-icon>
                </router-link>
                <v-icon color="red" @click.stop="confirmDelete(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
        <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Discounts
        <span
                :style="{'color':this.$vuetify.theme.themes.light.primary}"
        >{{count}}</span>
      </span>
            <v-spacer></v-spacer>
            <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
        </div>
    </v-card>
</template>

<script>
    import DeleteDialog from "../Dialogs/DeleteDialog";
    import DataTableMixin from "../../mixins/dataTable";
    import DeleteRow from "../../mixins/deleteRow";

    export default {
        name: "ClassTable",
        components: {
            DeleteDialog
        },
        mixins:[
            DataTableMixin,
            DeleteRow
        ],
        data() {
            return {
                delete_dialog: false,
                headers: [
                    {text: "SrNo.", sortable: true, value: "id"},
                    {text: "Discount", value: "amount", sortable: false},
                    {text: "Code", value: "code", sortable: false},
                    {text: "Type", value: "is_percent", sortable: false},
                    {text: "Description", value: "description", sortable: false},
                    {text: "Action", value: "action", sortable: false}
                ],
            };
        },
        methods: {
            deleteDiscount(){
                this.deleteConfirmLoading=true
                axios.delete(apiRoutes.discounts.url+this.current_row.id).then(response=>{
                    this.getItems()
                    this.deleteConfirmLoading=false
                    this.delete_dialog=false
                }).catch(error=>{

                })
            },
            getZeroAddedNum(num) {
                return num.toString().padStart(2, "0");
            },
            getItems(){
                this.loading=true
                axios.get(apiRoutes.discounts.url,{
                    params:this.formQueryParams()
                }).then(response=>{
                    this.formalizeTable(response.data)
                    this.loading=false
                })
            }
        },
        mounted() {
            this.getItems()
        }
    };
</script>

<style lang='scss'>
    .v-data-table-header th span {
        font: 300 14px Gotham;
        font-family: "Gotham Narrow";
        color: #8898aa;
    }

    .table-users {
        &-srno {
            font: 500 14px/13px Gotham;
            color: #172b4d;
        }

        &-name {
            display: block;
            font: 500 14px/13px Gotham;
            color: #6a158e;
        }

        &-email {
            font: 400 12px/13px Lato;
            color: #172b4d4d;
        }

        &-time {
            display: block;
            font: 400 11px/10px Lato;
            color: #0e0edff7;
        }

        &-days {
            font: 400 10px/15px Lato;
            color: #172b4db3;
        }

        &-status {
            font: 500 14px/13px Gotham;

            &.st-success {
                color: #129b11;
            }

            &.st-error {
                color: #e41b1bf7;
            }
        }

        &-tutor {
            font: 500 13.5px Gotham;
            color: #529b11;
        }
    }

    .v-btn.v-size--default {
        font-size: 12px;
        text-transform: none;
    }
</style>